import axios from 'axios';

export interface CommentItem {
    id: number;
    postId: number;
    author: string;
    content: string;
    createdAt: string;
    updatedAt?: string;
}

export interface CommentFormData {
    author?: string;
    password: string;
    content?: string;
}

export const getComments = async (postId: number) => {
    const response = await axios.get(`/api/posts/${postId}/comments`);
    return response.data as CommentItem[];
};

export const createComment = async (postId: number, data: Required<CommentFormData>, token?: string | null) => {
    const response = await axios.post(`/api/posts/${postId}/comments`, data, token ? {
        headers: { Authorization: `Bearer ${token}` },
    } : undefined);
    return response.data as CommentItem;
};

const buildAuthConfig = (token?: string | null) => token ? {
    headers: { Authorization: `Bearer ${token}` },
} : undefined;

export const verifyCommentPassword = async (commentId: number, password: string, token?: string | null) => {
    const response = await axios.post(`/api/comments/${commentId}/verify`, { password }, buildAuthConfig(token));
    return response.data as CommentItem;
};

export const updateComment = async (commentId: number, data: Pick<CommentFormData, 'password' | 'content'>, token?: string | null) => {
    const response = await axios.put(`/api/comments/${commentId}`, data, buildAuthConfig(token));
    return response.data as CommentItem;
};

export const deleteComment = async (commentId: number, password: string, token?: string | null) => {
    const response = await axios.delete(`/api/comments/${commentId}`, {
        data: { password },
        ...buildAuthConfig(token),
    });
    return response.data as { deleted: boolean };
};
